module.exports = __webpack_public_path__ + "static/media/lo-que-sea.cb3c4a45.png";